import React from 'react'


const ContactThanks = () => {
    return (
        <div className="contact-form-area pb-75">
            <div className="container">
                
               <div className="contact-form-info" data-cue="slideInUp">
    <div className="row">
        <div className="col-lg-6 col-md-6 mx-auto">
            <h1>Thanks for contacting us. We will be in touch shortly!</h1>
        </div>
    </div>
</div>
            </div>
        </div>
        
    )
}

export default ContactThanks